import App from './App';
import router from './router';
import store from './store'; // for saving global shared data
import server from './config';
import sdk from './sdk';
import Vue from 'vue';
import axios from 'axios';
import '@/plugins';
import { MpReset, ThemeProvider } from '@mekari/pixel';
import './styles/styles.scss';

Vue.prototype.$axios = axios; // set variable $axios
Vue.prototype.$newEndPoint = server.newEndPoint; // new Go service endpoint
Vue.prototype.$endPoint = server.endPoint; // set end point url based on host
Vue.prototype.$endPoint2 = server.endPoint2; // set end point url based on host
Vue.prototype.$nonCoreEndPoint = server.nonCoreEndPoint; // set general non core end point url based on host
Vue.prototype.$newNonCoreEndPoint = server.newNonCoreEndPoint; // set general non core end point url based on host Go
Vue.prototype.$coreBaseURL = server.coreBaseURL; // base url for Talenta core (hr.talenta.co)
Vue.prototype.$isUsingSSO = server.is_sso;
Vue.prototype.$sso = server.sso; // SSO url & id based on host
Vue.prototype.$intercomSettings = { intercomId: server.intercomId, intercomHash: server.intercomHash, intercomActive: server.intercomActive };
Vue.prototype.$setSDK = sdk;
Vue.prototype.$imgPath = server.imgPath;
Vue.prototype.$s3Path = server.s3Path;
Vue.prototype.$insight = server.insight;
Vue.prototype.$logo = store.state.assets.logoImg;
Vue.prototype.$contentHeight = 'calc(100vh - 60px - 72px)';
Vue.prototype.$contentHeightTab = 'calc(100vh - 60px - 72px - 58px)';

Vue.config.devtools = window.location.hostname === 'localhost';
Vue.config.productionTip = false;

new Vue({
  name: 'Vue',
  router,
  store,
  render: h => h(ThemeProvider, [h(App), h(MpReset)]),
}).$mount('#app-vue');
